// utils/aiAppletsGate.js
//
// The ONLY person-specific code in the AI features, and it names nobody itself: it reads
// the portal's super-admin list.
//
//   • the USER must be one of the portal's super admins (utils/superAdmins, seven ids).
//     Owner 2026-09-21: "We would like to only allow the list of super admins to use the
//     AI, we won't gate it by orgs, but by users." A super admin sees the AI features in
//     EVERY org they administer. History: owner only, in LACFFA + Tester Org 2.0
//     (2026-09-14); + the PM (09-15); the seven super admins, still in those two orgs
//     (09-18, the owner's ruling that day); the org list dropped (09-21).
//
// Call sites — and nothing else in the feature knows about any particular org
// or person:
//   • app/page.js                 — Home's "New AI Features" button
//   • app/addapplet/page.js       — the "Build it with AI" card and the "Build with AI" button
//   • app/aiapplets/page.js       — deep-link guard on the jobs/progress page
//   • components/ai/AiReviewSection.jsx — whether the applet page asks for a job
//   • app/formslibrary/page.js    — the "Build with AI" card and the Checklists button
//   • app/aiforms/page.js         — deep-link guard on the forms jobs page
//   • app/aidashboard/page.js, utils/portalNav.js — the AI Dashboard and its sidebar link
//
// TO OPEN IT TO EVERYONE: change isAiAppletsEnabled's body to `return true;`. No API deploy
// either way: the server's endpoints are org-admin gated and scoped by OrgId regardless
// of this file. (Every page that calls this also checks that the user administers the org.)

import { SUPER_ADMIN_IDS } from '@/utils/superAdmins';

/** Who may use the AI features: the portal's super admins, read from the one list so the two never drift. */
const AI_USER_IDS = SUPER_ADMIN_IDS;
export { AI_USER_IDS };

function onList(list, value) {
    if (!value || !String(value).trim()) return false;
    const v = String(value).trim().toLowerCase();
    return list.some(t => t.toLowerCase() === v);
}

/**
 * @param {string} orgId    the org the user is working in — any org, but there must be one
 * @param {string} userId   the signed-in user's id (`useAuth().user.id`)
 */
export function isAiAppletsEnabled(orgId, userId) {
    if (!orgId || !String(orgId).trim()) return false;
    return onList(AI_USER_IDS, userId);
}
